import React, {ReactElement, useEffect} from 'react';
import {Formik, Form, Field} from 'formik';
import {setTempPassword} from '../../../core/localstorage-data';
import * as Yup from 'yup';
import {EMPLOYEE_SIGNIN} from '../../../routes/route-constants';
import {useHistory} from 'react-router-dom';
import AppHeader from '../../../components/appbar/AppBar';
import {setPageName} from '../../../lib/tagmanager';
import {pageName} from '../../../lib/constants';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import {
  employeeforgetpasswordcall,
  employeeForgetPasswordData,
  error,
  loading,
} from '../../../redux/employeeForgetPasswordSlice';
import ErrorToast from '../../../components/notifications/ErrorToast';
import cogoToast from 'cogo-toast';
import SuccessToast from '../../../components/notifications/SuccessToast';

const employeeTempPassword = (): ReactElement => {
  const navigate = useHistory();
  const dispatch = useAppDispatch();
  const employeeTempPasswordData = useAppSelector(employeeForgetPasswordData);
  const employeeDataHasLoaded = useAppSelector(loading);
  const errorInEmployeeData = useAppSelector(error);
  useEffect(() => {
    setPageName(pageName.temppasswordpage);
  }, []);
  useEffect(() => {
    if (
      employeeTempPasswordData.statusMessage != '' &&
      employeeDataHasLoaded === false
    ) {
      if (employeeTempPasswordData.statusCode == '200') {
        cogoToast.success(
          <SuccessToast
            title="Success!"
            description={employeeTempPasswordData.statusMessage}
          />,
          {
            hideAfter: 3,
            renderIcon: () => {
              return null;
            },
          },
        );
        navigate.push(EMPLOYEE_SIGNIN);
      } else {
        cogoToast.error(
          <ErrorToast
            title="Error"
            description={employeeTempPasswordData.statusMessage}
          />,
          {
            hideAfter: 3,
            renderIcon: () => {
              return null;
            },
          },
        );
        return;
      }
    }
    if (errorInEmployeeData != '' && employeeDataHasLoaded === false) {
      cogoToast.error(
        <ErrorToast title="Error" description="Internal Server Error" />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [employeeTempPasswordData, employeeDataHasLoaded, errorInEmployeeData]);

  const initialValues = {
    employeeid: '',
    employeemail: '',
  };

  const validationSchema = Yup.object({
    employeeid: Yup.string()
      .max(40, 'Max length execeeding')
      .required('*Please enter employee id'),
    employeemail: Yup.string()
      .max(60, 'Max length execeeding')
      .email('Invalid email format')
      .required('*Please enter emailid'),
  });
  const onSubmit = (
    values: any,
    submitProps: {
      setSubmitting: (arg0: boolean) => void;
      resetForm: () => void;
    },
  ) => {
    submitProps.setSubmitting(false);
    console.log(values);
    setTempPassword();

    const parameter = {
      userId: values.employeeid,
      email: values.employeemail,
    };

    dispatch(employeeforgetpasswordcall(parameter));

    submitProps.resetForm();
  };

  return (
    <div className="h-full">
      <AppHeader bgColor="transparent" />
      <div className="py-4 px-8 top-spacing-ipad">
        <div className="grid place-items-center overflow-y-auto">
          <span className="font-roboto text-big text-center font-bold">
            Reset password
          </span>
        </div>
        <div className="mt-2">
          <p className="text-sm mt-2 text-black_zero text-center text-opacity-50 font-roboto">
            Enter email ID to receive temporary password and password reset
            link.
          </p>
        </div>
        <div className="mt-1">
          <Formik
            className="flex justify-items-stretch mx-auto max-w-screen-md relative flex-grow mt-6"
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize>
            {formik => {
              return (
                <Form>
                  <div>
                    <div
                      className={`grid h-50 border-opacity-50 py-1 rounded-radius10  bg-blue_four hover:bg-white   ${
                        formik.errors.employeeid && formik.touched.employeeid
                          ? // && formik.values.firstname.length > 0
                            'input_error'
                          : 'input_valid'
                      }`}>
                      <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                        Employee ID
                        <span className="text-dark_red">*</span>
                      </span>
                      <Field
                        type="text"
                        name="employeeid"
                        placeholder="Enter X digit employee ID"
                        className="focus:outline-none w-10/12 font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                      />
                    </div>
                    {formik.errors.employeeid && formik.touched.employeeid ? (
                      <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                        {formik.errors.employeeid}
                      </div>
                    ) : null}
                  </div>
                  <div className="mt-6">
                    <div
                      className={`grid h-50 border-opacity-50 py-1 rounded-radius10  bg-blue_four hover:bg-white   ${
                        formik.errors.employeemail &&
                        formik.touched.employeemail
                          ? // && formik.values.firstname.length > 0
                            'input_error'
                          : 'input_valid'
                      }`}>
                      <span className="text-black_zero text-xs text-left font-roboto ml-2.5 mt-1.5 font-bold">
                        Registered Email ID{' '}
                        <span className="text-dark_red">*</span>
                      </span>
                      <Field
                        type="email"
                        name="employeemail"
                        placeholder="Enter email ID@landmarkgroup.com"
                        className="focus:outline-none w-10/12 font-roboto text-sm ml-2.5 -mt-2 bg-transparent"
                      />
                    </div>
                    {formik.errors.employeemail &&
                    formik.touched.employeemail ? (
                      <div className="text-red-600 text-xs font-roboto ml-2.5 mt-1">
                        {formik.errors.employeemail}
                      </div>
                    ) : null}
                  </div>
                  <div style={{marginTop: '24px'}}>
                    <button
                      className={`cursor-none-allowed text-white h-50 rounded-radius10  grid place-items-center focus:outline-none w-full text-center primary normal`}
                      type="submit"
                      disabled={!(formik.dirty && formik.isValid)}>
                      <p className="font-bold font-roboto">Continue</p>
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default employeeTempPassword;
